import { useTranslation } from "react-i18next";
import * as Yup from "yup";

const expressionMatch = /^[x0-9\s+\-/*.,]+$/g;

export function useSegmentBulkSchema() {
  const { t } = useTranslation();

  const schema = Yup.object().shape({
    roadType: Yup.string().required(
      t("label.isRequiredValidation", {
        field: t("label.roadType"),
      })
    ),
    height_m: Yup.string()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.height"),
        })
      )
      .matches(expressionMatch, t("label.invalidExpression")),
    speed_km_h: Yup.string()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.speedLimit"),
        })
      )
      .matches(expressionMatch, t("label.invalidExpression")),

    vehicleCounts: Yup.array().of(
      Yup.object().shape({
        count: Yup.string()
          .required(
            t("label.isRequiredValidation", {
              field: t("label.thisField"),
            })
          )
          .matches(expressionMatch, t("label.invalidExpression")),
      })
    ),
  });
  return schema;
}
